import { useDispatch, useSelector } from 'react-redux';
import React, { useEffect, useState } from 'react';
import { changeEditorStatus, setTitlePlaceholderColorRed } from '../../actions';
import { setDraftSequence, updateDraftCount } from '../../actions/post';
import { STATUS_DRAFT, STATUS_EDITOR } from '../../constants/EditorStatus';
import axios from 'axios';
import { showToast } from '../../components/common/Toast';
import differenceInSeconds from 'date-fns/differenceInSeconds';

export default function DraftButton () {
  const post = useSelector(state => state.post.newPost);
  const draftCount = useSelector(state => state.post.draftCount);
  const canPublish = useSelector(state => state.post.uploadProgressCount === 0);
  const editorStatus = useSelector(state => state.env.editorStatus);
  const draftSequence = useSelector(state => state.post.draftSequence);
  const dispatch = useDispatch();
  const [lastSaveTime, setLastSaveTime] = useState(new Date(0));

  const [fetching, setFetching] = useState(false);

  function handleChangeEditorStatus (status) {
    dispatch(changeEditorStatus(status));
  }
  function handleUpdateDraftCount (count) {
    dispatch(updateDraftCount(count));
  }

  // 한번 저장하면 2초 뒤에 또 할수 있다.
  function throttleCheck () {
    return differenceInSeconds(Date.now(), lastSaveTime) < 2;
  }

  function saveDraft () {
    if (!canPublish || editorStatus !== STATUS_EDITOR || fetching || throttleCheck()) {
      return;
    }

    setFetching(true);
    const tags = post.tags.join(',');

    axios.post(draftSequence ? `${appInfo.manageUrl}/drafts/${draftSequence}` : `${appInfo.manageUrl}/drafts`, {
      title: post.title,
      content: post.content,
      tags,
      categoryId: post.category,
      thumbnail: post.thumbnail,
    }).then(r => {
      handleUpdateDraftCount(r.data.total);
      dispatch(setDraftSequence(r.data.draft.sequence));
      showToast('작성 중인 글이 저장되었습니다.', 2000);
    }).catch(e => {
      if (e.response.data && e.response.data.code === 'CONTENT_OR_TITLE_REQUIRED') {
        dispatch(setTitlePlaceholderColorRed(true));
        document.getElementsByClassName('textarea_tit')[0].focus();
      } else if (e.response.data && e.response.data.message) {
        alert(e.response.data.message);
      }

      console.error(e);
    }).finally(() => {
      setFetching(false);
      setLastSaveTime(Date.now());
    });
  }

  function handleOpenDraft () {
    if (!canPublish) {
      return;
    }
    handleChangeEditorStatus(STATUS_DRAFT);
  }

  return (
    <span className="btn btn-draft">
      {fetching
        ? <span className='txt'>저장 중</span>
        : <>
          <a href="#" role="button" className="action" onClick={saveDraft}>임시저장</a>
          <a href="#" role="button" aria-expanded={editorStatus === STATUS_DRAFT}
            aria-label={`임시저장 개수 ${draftCount}개`} className="count" onClick={handleOpenDraft}>
            {draftCount}
          </a>
        </>}
    </span>
  );
}
